import { Box, Paper, Typography } from "@mui/material";
import { ITarefaCard, ITarefaStatus } from "services/modules/quadroTarefas";
import { TarefaCard } from "./TarefaCard";

interface KanbanColumnProps {
  coluna: ITarefaStatus;
  tarefas: ITarefaCard[];
  onClickCard: (idTarefa: number) => void;
  // 3.1.2 — callbacks aceitam idSubtarefa opcional (cronometrar subtarefa).
  onPlayTimer?: (idTarefa?: number, idSubtarefa?: number) => void;
  onStopTimer?: (idTarefa?: number, idSubtarefa?: number) => void;
  timerAtivoIdTarefa?: number | null;
  onDropTarefa?: (idTarefa: number, idStatusNovo: number) => void;
}

/**
 * Coluna do Kanban
 */
export const KanbanColumn = ({
  coluna,
  tarefas,
  onClickCard,
  onPlayTimer,
  onStopTimer,
  timerAtivoIdTarefa,
  onDropTarefa,
}: KanbanColumnProps) => {
  const tarefasDaColuna = tarefas.filter(
    (t) => t.idTarefaStatus === coluna.idTarefaStatus
  );

  const handleDragOver = (e: React.DragEvent) => {
    e.preventDefault();
  };

  const handleDrop = (e: React.DragEvent) => {
    e.preventDefault();
    const idTarefa = parseInt(e.dataTransfer.getData("idTarefa"), 10);

    // Ignorar drop com id inválido (NaN)
    if (isNaN(idTarefa) || !onDropTarefa) return;

    // Ignorar drop na própria coluna de origem
    const tarefaOrigem = tarefas.find((t) => t.idTarefa === idTarefa);
    if (tarefaOrigem && tarefaOrigem.idTarefaStatus === coluna.idTarefaStatus) {
      return;
    }

    onDropTarefa(idTarefa, coluna.idTarefaStatus);
  };

  return (
    <Paper
      elevation={0}
      sx={{
        minWidth: 300,
        maxWidth: 300,
        backgroundColor: coluna.cor || "#f5f5f5",
        borderRadius: 2,
        display: "flex",
        flexDirection: "column",
        maxHeight: "calc(100vh - 200px)",
      }}
      onDragOver={handleDragOver}
      onDrop={handleDrop}
    >
      {/* Header da Coluna */}
      <Box
        sx={{
          p: 1.5,
          borderBottom: "1px solid rgba(0,0,0,0.1)",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography variant="subtitle2" fontWeight="bold">
          {coluna.nome}
        </Typography>
        <Typography
          variant="caption"
          sx={{
            backgroundColor: "rgba(0,0,0,0.1)",
            px: 1,
            py: 0.25,
            borderRadius: 1,
          }}
        >
          {tarefasDaColuna.length}
        </Typography>
      </Box>

      {/* Cards */}
      <Box
        sx={{
          p: 1,
          overflowY: "auto",
          flexGrow: 1,
          "&::-webkit-scrollbar": {
            width: 6,
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "rgba(0,0,0,0.2)",
            borderRadius: 3,
          },
        }}
      >
        {tarefasDaColuna.length === 0 ? (
          <Box
            sx={{
              textAlign: "center",
              py: 4,
              color: "text.secondary",
            }}
          >
            <Typography variant="body2">Nenhuma tarefa</Typography>
          </Box>
        ) : (
          tarefasDaColuna.map((tarefa) => (
            <Box
              key={tarefa.idTarefa}
              draggable
              onDragStart={(e) => {
                e.dataTransfer.setData("idTarefa", tarefa.idTarefa.toString());
              }}
            >
              <TarefaCard
                tarefa={tarefa}
                onClickCard={onClickCard}
                onPlayTimer={onPlayTimer}
                onStopTimer={onStopTimer}
                timerAtivoIdTarefa={timerAtivoIdTarefa}
              />
            </Box>
          ))
        )}
      </Box>
    </Paper>
  );
};

